import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@hover/blueprint';
import { iCheckCircle } from '@hover/icons';
import { SolutionTestimonyItem } from '../interfaces/ISolutionTestimony';
import { IProsRestorationInfo } from '../interfaces/IProsRestorationInfo';
import { ISolutionPoints } from '../interfaces/ISolutionPoints';

export const DESIGN_ORDERS_TESTIMONIES: SolutionTestimonyItem[] = [
  {
    quote: `Ultimately, this visualization is what sells the job. Homeowners see exactly what they want and then they easily hand over a check.`,
    name: 'TERRY SATTERWAITE',
    role: 'RAPID ROOFING',
    image: (
      <Box width="289px">
        <StaticImage
          objectFit="contain"
          src="../assets/images/material_list_testimony_1.png"
          alt=""
        />
      </Box>
    ),
    logo: (
      <StaticImage
        src="../assets/images/material_list_testimony_logo_1.jpeg"
        alt="J&B"
        width={98}
      />
    ),
    id: 1,
  },
];

export const HOW_IT_WORKS: Array<IProsRestorationInfo> = [
  {
    id: 0,
    icon: iCheckCircle,
    header: 'Send instructions',
    body: 'Send us the scope of changes, materials, colors and inspiration. ',
  },
  {
    id: 1,
    icon: iCheckCircle,
    header: 'Get your designs',
    body: 'We’ll return picture perfect designs in 4 days or less.',
  },
  {
    id: 2,
    icon: iCheckCircle,
    header: 'Edit & win jobs',
    body: 'Request major revisions or start editing with your customers.',
  },
];

export const WHAT_WILL_YOU_GET_POINTS: ISolutionPoints['items'] = [
  {
    id: 1,
    content: 'Up to 4 unique views (angles, designs, etc)',
  },
  {
    id: 2,
    content: 'Ability to edit siding, roofing, windows and more',
  },
  {
    id: 3,
    content: 'Ability to edit siding, roofing, windows and more',
  },
];
